import React from 'react'

import styles from './DataTable.module.css'

export default ({value, highlight, errorMessage=""}) => {
    const highlightStyle = highlight ? {'backgroundColor': highlight} : null
    return (
        <td style={highlightStyle} className={styles.cellContainer}>{value}{errorMessage ? <div className="badge error">{errorMessage}</div>: ""}</td>
    )
}